import { createFileRoute } from '@tanstack/react-router'
import { ThemeConfig } from '~/features/webchat/components'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/theme')({
  component: Component,
})

function Component() {
  const { workspaceId, botId } = Route.useParams()

  return <ThemeConfig workspaceId={workspaceId} botId={botId} />
}
